<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<livechat-widget 
  license="17708787"
  visibility="minimized"
  [customerEmail]="userEmail$|async"
  [customerName]="userName$|async"
  [customIdentityProvider]="livechatService.getIdentityProvider()"></livechat-widget>
<router-outlet></router-outlet>
